import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Flex, Label } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { FastField as Field, type FieldProps } from 'formik';
import { TextArea } from '../TextArea';
import { GridFormField } from './FormField';

interface Props {
  name: string;
  label?: string;
  customLabel?: string;
  placeholder?: string;
  minHeight?: string;
  textAreaProps?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;
  comment?: string;
}

export const FormTextArea = (props: Props) => (
  <Field name={props.name}>
    {({ field, meta }: FieldProps) =>
      !props.customLabel ? (
        <GridFormField label={props?.label}>
          <Box mt={10}>
            <TextArea
              minHeight={props.minHeight}
              placeholder={props.placeholder}
              textAreaProps={{ ...props.textAreaProps, name: field.name }}
              value={field.value}
              onChange={field.onChange}
              errorMessage={(meta.touched && meta.error) || ''}
            />
          </Box>
        </GridFormField>
      ) : (
        <Flex flexDirection='column' gap={10}>
          <Flex flexDirection='column' gap={5}>
            <Label>{props.customLabel}</Label>
            <Typography fontSize={theme.fontSizes['14']}>{props.comment}</Typography>
          </Flex>
          <TextArea
            minHeight={props.minHeight}
            placeholder={props.placeholder}
            textAreaProps={{ ...props.textAreaProps, name: field.name }}
            value={field.value}
            onChange={field.onChange}
            errorMessage={(meta.touched && meta.error) || ''}
          />
        </Flex>
      )
    }
  </Field>
);
